import { render, staticRenderFns } from "./_number.vue?vue&type=template&id=0fea038a&"
import script from "./_number.vue?vue&type=script&lang=js&"
export * from "./_number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports